import { EditIcon as EditIconSVG } from "lucide-react";
import ModalPrompt from "./ModalPrompt";

interface EditButtonProps {
    onClick: (modalPrompt: ModalPrompt) => void;
    modalPrompt: ModalPrompt;
}

const EditButton: React.FC<EditButtonProps> = ({ onClick, modalPrompt }) => {
    return (
        <div
            onClick={(event) => {
                event.preventDefault();
                onClick(modalPrompt);
            }}
            className="flex items-center text-base ml-auto text-[#2476f2] font-normal hover:text-blue-700 transition-colors duration-200"
        >
            Edit
            <div className='pl-1.5 flex items-center'>
                <EditIconSVG />
            </div>
        </div>
    );
}

interface EditIconProps {
    width?: number | string;
    height?: number | string;
}

const EditIcon: React.FC<EditIconProps> = ({ width = 24, height = 24 }) => {
    return (
        <svg
            className="flex-shrink-0"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 5H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5l3 3L11 16l-4 1 1-4 10.5-10.5z" />
            <line x1="16" y1="5" x2="19" y2="8" />
        </svg>
    );
};

export default EditButton;
export { EditIcon };
